import { useEffect, useState } from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL;

export default function useGraveSearch(query, pageNumber, showGraveForm) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [graves, setGraves] = useState([])
  const [hasMore, setHasMore] = useState(true)
  const [firstInitialization, setFirstInitialization] = useState(true)

  useEffect(() => {
    setGraves([]);
  }, [query])

  useEffect(() => {
    if (showGraveForm === false) {
      setGraves([]);
      setError(false);
      setLoading(false);
      setHasMore(true);
    }
  }, [showGraveForm]);

  useEffect(() => {
    if (!firstInitialization) {
      fetchData();
    } else {
      setFirstInitialization(false)
    }
  }, [query, pageNumber, firstInitialization])

  const fetchData = () => {
    if (loading || !hasMore) return;
    setLoading(true)
    setError(false)
    let cancel
    axios({
      method: 'GET',
      url: API_URL + "/graves",
      params: { page: pageNumber},
      cancelToken: new axios.CancelToken(c => cancel = c)
    }).then(res => {
      setGraves(prevGraves => {
        return [...new Set([...prevGraves, ...res?.data?.content])]
      })
      if (res?.data?.page) setHasMore(res?.data?.page?.totalPages > (pageNumber + 1))
    }).catch(e => {
      if (axios.isCancel(e)) return
      if (error?.response?.data?.code === "no_graves_found") setHasMore(false);
      if ((error?.response?.data?.code !== "no_graves_found") && (error?.response?.data?.code === "no_graves_found" && pageNumber !== 0)) {
        setError(true);
      }
    }).finally(() => {
      setLoading(false);
    });
    return () => cancel()
  }

  return { loading, error, graves, hasMore }
}